<template>
  <div>
    <el-row class="wenzi">
      数字版权登记
      <!-- <el-button
        @click="toAddCdi"
        type="primary"
        class="btn-upd"
        icon="el-icon-plus"
      >
        录入DCI
      </el-button> -->
    </el-row>
    <el-row>
      <el-tabs v-model="activeName" @tab-click="search" class="status-tabs" stretch>
        <el-tab-pane
          :name="item.value"
          v-for="item in applyTypeList"
          :key="item.value"
        >
          <span slot="label">
            <el-badge :value="item.num || 0" :max="99">
              {{ item.label }}
            </el-badge>
          </span>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row>
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline table-dci"
      >
        <el-form-item>
          <el-input
            v-model="formInline.searchValue"
            placeholder="输入作品名/称流水号/DCI登记号/著作权人进行查询"
            class="input-with-select-cc"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>

        <!-- <el-form-item v-if="activeName === 'PAY'">
          <el-button type="primary" :disabled="!canBatchPay" @click="onBatchPay">汇总支付</el-button>
        </el-form-item> -->

        <el-form-item v-if="activeName === 'FINISH'">
          <el-button type="primary" :disabled="!canBatchCertificateDownload" @click="onBatchCertificateDownload">汇总证书下载</el-button>
        </el-form-item>

        <el-form-item v-if="isAdmin && activeName === 'FINISH' && canBatchInvoiceDownload">
          <el-button type="primary" :disabled="!hasInvoiceToDownload" @click="onBatchInvoiceDownload">汇总发票下载</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table
        :data="tableData"
        border
        class="table-dci"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column fixed prop="date" label="作品详情" width="600">
          <template slot-scope="scope">
            <div>
              流水号: {{ scope.row.dciWorkId }}
              <span
                v-if="scope.row.digitalRegisterCompletionTime"
                class="showTime-cc"
                >下证时间：{{
                  scope.row.digitalRegisterCompletionTime.replace('T', ' ')
                }}</span
              >
            </div>
            <div>
              {{ getLabelByValue(scope.row.workCategory, workCategoryType) }}
            </div>
            <div class="showName" @click="toDetail(scope.row)">
              {{ scope.row.workName }}
            </div>
            <div class="showApp">{{ scope.row.showApplyInfo }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="状态" width="220">
          <template slot-scope="scope">
            <div class="status-info">
              <!-- PAY: 显示费用 -->
              <template v-if="scope.row.digitalRegisterStatus === 'PAY'">
                <span v-if="scope.row.serviceFeeStatus === 'PAIED'" class="showStatus">审查中</span>
                <span v-else class="showStatus">费用：<span>{{ scope.row.serviceFee || '' }}</span></span>
              </template>
              <!-- 其它状态 -->
              <template v-else>
                <span class="showStatus">{{ getLabelByValue(scope.row?.digitalRegisterStatus || '', statusList) }}</span>
              </template>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              v-if="scope.row.digitalRegisterStatus == 'NO_APPLY'"
              @click="copyrightCertificate(scope.row)"
              >申领数字版权证书</el-button
            >
            <el-button
              type="primary"
              v-if="getCanDownloadCertificate(scope.row)"
              :loading="scope.row.loadingDWN"
              @click="CertificateDownloadClick(scope.row)"
            >
              证书下载</el-button
            >
            <el-button
              type="primary"
              v-if="getIsContinuePay(scope.row)"
              @click="payClick(scope.row)"
              >继续支付</el-button
            >
            <el-button
              type="primary"
              v-if="getIsCanPay(scope.row)"
              @click="payClick(scope.row)"
              >立刻支付</el-button
            >
            <el-button
              type="primary"
              v-if="isAdmin && getCanDownloadInvoice(scope.row)"
              :loading="scope.row.loadingDWN"
              @click="fapiaoficateDownloadClick(scope.row)"
            >
              发票下载</el-button
            >

            <!-- <el-button
              type="primary"
              v-if="succet(scope.row)"
              @click="
                () => {
                  refundClickinfo = scope.row
                  dialogVisibletuikuan = true
                }
              "
              >发起退款</el-button
            > -->

            <el-button
              type="primary"
              v-if="updBtnShow(scope.row)"
              @click="copyrightCertificate(scope.row, 'TOBE_AMEND')"
              >修改</el-button
            >

            <!-- 替换dci修改 -->
            <el-button
              type="primary"
              v-if="
                scope.row.digitalRegisterStatus == 'TOBE_AMEND' &&
                scope.row.amendType == 'REPLACE_DCI'
              "
              @click="copyrightCertificate(scope.row, 'REPLACE_DCI')"
            >
              修改（DCI替换）
            </el-button>

            <!-- 管理员删除按钮：已下证或未申请状态 -->
            <el-button
              type="danger"
              v-if="isAdmin && (scope.row.digitalRegisterStatus == 'NO_APPLY')"
              @click="adminCancelClick(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row class="table-dci pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>

    <el-dialog title="支付提示" :visible.sync="dialogVisible" width="50%">
      <div>
        付款成功后该订单下的所有产品都将运入后台审核阶段，请持续关注列表状态（也可手动刷新）。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleClick">知道啦</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="发起退款提示"
      :visible.sync="dialogVisibletuikuan"
      width="50%"
    >
      <div class="dialog-tuikuan-z">
        <div>
          注意：点击【退款】按钮后，仅您所支付得服务费将原路退回到您用于支付的支付宝账户中。
        </div>
        <div>
          中国版权保护中心收取的80元官费请填写以下表格（一式两份）+著作权人的身份证明文件复印件（签章），由著作权人签章后邮寄到中国版权保护中心，数字版权登记部门。中国版权保护中心将在收到申请后约30个工作日内完成退费。
        </div>
        <div>
          <el-button type="text" @click="downloadtuiClick"
            >官费退费申请表.doc</el-button
          >
        </div>
        <div>
          收件地址： 北京市丰台区汽车博物馆西路9号院6号楼 数字著作权部（邮编
          100070）
        </div>
        <div>收件人：杨老师</div>
        <div>联系电话：83771624</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibletuikuan = false"
          >考虑一下</el-button
        >
        <el-button @click="refundClick">我已知晓，立刻退款</el-button>
      </span>
    </el-dialog>

    <!-- 支付弹窗 -->
    <PaymentDialog ref="paymentDialog" />
  </div>
</template>
<script>
import PaymentDialog from '@/components/PaymentDialog.vue'
import {
  registrationList,
  workDelete,
  payDigitalReg,
  payRecordScreen,
  dciGetPayUrl,
  registrationStatusCount,
  getPayResult,
  refund,
  downloadBatch,
  cancelDciWork
} from '@/api/user.js'
import { getToken } from '@/utils/auth'
import { apiUrl } from '@/config'
import { downloadFileByUrl, downloadFileByBlob, toNumber, openPaymentWindow } from '@/utils/index'
import { PAY_TYPE } from '@/utils/constants'

export default {
  name: 'DCIRegistration',
  components: { PaymentDialog },
  mixins: [],
  props: {},
  data () {
    return {
      refundClickinfo: {},
      dialogVisibletuikuan: false,
      dialogVisible: false,
      tableData: [],
      workCategoryType: [
        {
          /**
           * 文字作品，支持文件类型 TEXT
           */
          value: 'WORD',
          label: '文字作品'
        },
        {
          /**
           * 口述作品，支持文件类型 AUDIO
           */
          value: 'ORAL',
          label: '口述作品'
        },
        {
          /**
           * 音乐作品，支持文件类型 AUDIO
           */
          value: 'MUSIC',
          label: '音乐作品'
        },
        {
          /**
           * 戏剧作品，支持文件类型 TEXT
           */
          value: 'DRAMA',
          label: '戏剧作品'
        },
        {
          /**
           * 曲艺作品，支持文件类型 TEXT
           */
          value: 'QUYI',
          label: '曲艺作品'
        },
        {
          /**
           * 舞蹈作品，支持文件类型 VIDEO
           */
          value: 'DANCE',
          label: '舞蹈作品'
        },
        {
          /**
           * 杂技作品，支持文件类型 VIDEO
           */
          value: 'ACROBATICS',
          label: '杂技作品'
        },
        {
          /**
           * 美术作品，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'ART',
          label: '美术作品'
        },
        {
          /**
           * 建筑作品，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'ARCHITECTURE',
          label: '建筑作品'
        },
        {
          /**
           * 摄影作品，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'PHOTOGRAPHY',
          label: '摄影作品'
        },
        {
          /**
           * 电影作品，支持文件类型 VIDEO
           */
          value: 'MOVIE',
          label: '电影作品'
        },
        {
          /**
           * 类似摄制电影方法创作的作品，支持文件类型 VIDEO
           */
          value: 'AUDIOVISUAL',
          label: '类似摄制电影方法创作的作品'
        },
        {
          /**
           * 工程设计图、产品设计图，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'DESIGN',
          label: '工程设计图、产品设计图'
        },
        {
          /**
           * 示意图，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'DIAGRAM',
          label: '示意图'
        },
        {
          /**
           * 模型，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: 'MODEL',
          label: '模型'
        }
      ],
      // 状态列表
      statusList: [
        { value: 'TOTAL', label: '全部' },
        { value: 'NO_APPLY', label: '未申请' },
        { value: 'SUBMITED', label: '已提交' },
        { value: 'CHECK', label: '初审中' },
        { value: 'PAY', label: '待支付' },
        { value: 'PAIED', label: '已支付' },
        { value: 'PAYING', label: '支付中' },
        { value: 'REVIEW', label: '审查中' },
        { value: 'TOBE_AMEND', label: '待补正' },
        { value: 'DISREGARD', label: '不予受理' },
        { value: 'FINISH', label: '已下证' },
        { value: 'REFUNDED', label: '已退款' },
        { value: 'REFUNDING', label: '退款中' },
        { value: 'CHECK_FAIL', label: '待补正' }, // 初审失败
        { value: 'AMEND_CHECK_FAIL', label: '待补正' }, // 待补正审核不通过
        { value: 'REGISTRATION_STOPING', label: '退款确认中' }, //申请停止中
      ],
      applyTypeList: [
        {
          value: 'TOTAL',
          label: '全部',
          pageNum: 36
        },
        {
          value: 'NO_APPLY',
          label: '未申请'
        },
        {
          value: 'CHECK',
          label: '初审中'
        },
        {
          value: 'PAY',
          label: '待支付'
        },
        {
          value: 'REVIEW',
          label: '审查中'
        },
        {
          value: 'TOBE_AMEND',
          label: '补正'
        },
        {
          value: 'DISREGARD',
          label: '不予受理'
        },
        {
          value: 'FINISH',
          label: '已下证'
        },
      ],

      // 总数量
      total: 0,
      currentPage: 1,
      pageSize: 10,
      multipleSelection: [], // 表格数据
      formInline: {
        searchValue: '',
        applyType: ''
      },
      activeName: 'TOTAL', // 选中的标签页
      loadingDWN: false
    }
  },
  created () {
    registrationStatusCount({
      dciWorkStatus: '',
      searchValue: this.formInline.searchValue,
      params: {
        beginTime: '',
        endTime: '',
        applyType: '',
        status: this.activeName
      }
    }).then(res => {
      res.data.forEach(item => {
        this.applyTypeList.forEach((applyType, index) => {
          if (item.key === applyType.value) {
            this.applyTypeList[index].num = item.count
          }
        })
      })
    })
    this.search()
  },
  computed: {
    // 计算属性绑定到Vuex store中的userInfo
    realInformation () {
      return this.$store.state.realInformation
    },
    // 是否为管理员
    isAdmin () {
      return this.$store.getters.isAdmin
    },
    // 是否可以批量下载发票（需要 userId == 1）
    canBatchInvoiceDownload () {
      console.log(this.realInformation)
      return true
      return this.realInformation.userId == 1
    },
    canBatchPay () {
      return this.multipleSelection.some(row => this.getIsCanPay(row))
    },
    canBatchCertificateDownload () {
      return this.multipleSelection.some(row => this.getCanDownloadCertificate(row))
    },
    hasInvoiceToDownload () {
      return this.multipleSelection.some(row => this.getCanDownloadInvoice(row))
    }
  },
  watch: {},
  async mounted () {},
  methods: {
    /** 获取排序字段 */
    getOrderByColumn() {
      switch (this.activeName) {
        case 'FINISH':
          return 'dr.digitalRegisterCompletionTime'
        case 'NO_APPLY':
          return 'dw.dci_work_id'
        default:
          return 'dr.create_time'
      }
    },
    getIsCanPay(row){
      return row.digitalRegisterStatus == 'PAY' && row.serviceFeeStatus != 'PAIED'
    },
    getIsContinuePay(row){
      return row.digitalRegisterStatus == 'PAYING' && row.serviceFeeStatus != 'PAIED'
    },
    // 判断是否可以下载证书
    getCanDownloadCertificate (row) {
      return row.digitalRegisterStatus == 'FINISH' && row.downloadUrl
    },
    // 判断是否可以下载发票
    getCanDownloadInvoice (row) {
      return row.invoiceUrlList && row.invoiceUrlList.length > 0 && this.canBatchInvoiceDownload
    },
    // 汇总证书下载
    async onBatchCertificateDownload () {
      const downloadList = this.multipleSelection.filter(row => this.getCanDownloadCertificate(row))
      if (downloadList.length === 0) {
        this.$message.warning('没有可下载的证书，请选择已下证且有证书的记录')
        return
      }
      try {
        const fileList = downloadList.map(row => (row.downloadUrl))
        const res = await downloadBatch(fileList)
        await downloadFileByBlob(res, '证书批量下载.zip')
      } catch (error) {
        this.$message.error(error.message || '下载失败')
      }
    },
    // 汇总发票下载
    async onBatchInvoiceDownload () {
      const downloadList = this.multipleSelection.filter(row => this.getCanDownloadInvoice(row))
      if (downloadList.length === 0) {
        this.$message.warning('没有可下载的发票，请选择有发票的记录')
        return
      }
      try {
        const fileList = downloadList.map(row => (row.invoiceUrlList[0]))
        const res = await downloadBatch(fileList)
        await downloadFileByBlob(res, '发票批量下载.zip')
      } catch (error) {
        this.$message.error(error.message || '下载失败')
      }
    },
    downloadtuiClick () {
      window.open('http://47.120.2.9/20250320155649.docx', '_blank')
    },
    updBtnShow (row) {
      if (row.digitalRegisterStatus === 'CHECK_FAIL') {
        return true
      }
      if (
        row.digitalRegisterStatus === 'TOBE_AMEND' ||
        row.digitalRegisterStatus === 'AMEND_CHECK_FAIL'
      ) {
        return true
      }
      return false
    },
    succet (row) {
      if (
        row.digitalRegisterStatus === 'TOBE_AMEND' ||
        row.digitalRegisterStatus === 'AMEND_CHECK_FAIL'
      ) {
        if (
          row.amendType === 'REPLACE_DCI' ||
          row.amendType === 'NO_NEED_REPLACE_DCI'
        ) {
          return true
        }
      }
      return false
    },
    toDetail (row) {
      const fullURL = window.location.href
      const urlBeforeHash = fullURL.split('#')[0]
      let url =
        urlBeforeHash +
        `#/InfoLock?dciWorkId=${row.dciWorkId}&dciContentId=${row.dciContentId}`
      // 在新窗口中打开
      window.open(url, '_blank')
    },
    getLabelByValue (value, works) {
      const found = works.find(work => work.value === value)
      return found ? found.label : value
    },
    // 申领数字版权证书
    async copyrightCertificate (row, type) {
      this.$router.push({
        path: '/DigitalCopyrightRegistrationEdit',
        query: {
          dciWorkId: row.dciWorkId,
          dciContentId: row.dciContentId,
          type: type
        }
      })
    },
    // 查询列表
    async search () {
      const res = await registrationList(
        {
          digitalRegisterStatus: '',
          searchValue: this.formInline.searchValue,
          params: {
            beginTime: '',
            endTime: '',
            applyType: '',
            status: this.activeName
          }
        },
        {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          tableName: undefined,
          tableComment: undefined,
          isAsc: 'desc',
          orderByColumn: this.getOrderByColumn()
          // orderByColumn: 'dr.digitalRegisterCompletionTime'
        }
      )

      console.log(res, 'res')
      if (res.code == 200) {
        this.tableData = res.rows.map(item => {
          return {
            ...item, // 保留原有属性
            loadingDWN: false // 添加新的属性
          }
        })
        // // 添加测试数据
        // this.tableData = [
        //   ...res.rows,
        //   {
        //     totalAmount: '0.00',
        //     dciWorkId: '2025Z11L000000002',
        //     record_screen_pay_status: 'NO_PAY',
        //     workCategory: 'WORD',
        //     authorName: '诸葛亮',
        //     showApplyInfo: '我申请',
        //     monitor_pay_status: 'NO_PAY',
        //     workName: '出师表',
        //     showCode: '2025Z11L000000002',
        //     dciWorkStatus: 'DCI_PRE_REG_FAIL',
        //     dciUserId: 'DUSANDBOX8250207000000697929',
        //     fileType: 'TEXT'
        //   }
        // ]

        this.total = res.total
      } else {
        this.$message.error('查询作品列表失败' + res.msg)
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.search()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.search()
    },
    // 删除作品
    workDeleteClick (row) {
      this.$confirm('此操作将永久删除该作品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await workDelete({
          dciWorkId: row.dciWorkId
        })
        if (res.code == 200) {
          this.$message.success('删除成功')
          this.search()
        } else {
          this.$message.error('删除失败' + res.msg)
        }
      }).catch(() => {})
    },
    // 证书下载
    async CertificateDownloadClick (row) {
      if (!row.downloadUrl) {
        this.$message.error('下载失败: 下载链接有误')
        return
      }
      var url =
        apiUrl +
        '/common/download?fileName=' +
        encodeURIComponent(row.downloadUrl) +
        '&Authorization=' +
        getToken()
      try {
        await downloadFileByUrl(url, row.workName + '_证书.zip')
        // const res = await downloadBatch([row.downloadUrl])
        // downloadFileByBlob(res, row.workName + '_证书.pdf')
      } catch (error) {
        this.$message.error('下载失败')
      }
    },
    async fapiaoficateDownloadClick (row) {
      if (!row.invoiceUrlList || !row.invoiceUrlList.length > 0) {
        this.$message.error('下载失败: 下载链接有误')
        return
      }
      var url =
        apiUrl +
        '/common/download?fileName=' +
        encodeURIComponent(row.invoiceUrlList[0]) +
        '&Authorization=' +
        getToken()
      try {
        await downloadFileByUrl(url, row.workName + '_发票.pdf')
        // const res = await downloadBatch([row.invoiceUrlList[0]])
        // downloadFileByBlob(res, row.workName + '_发票.pdf')
      } catch (error) {
        this.$message.error('下载失败')
      }
    },
    // 立刻支付
    async payClick (row) {
      // TODO: 调用支付宝支付接口
      if (row.serviceFeeStatus == 'PAYING') {
        // 支付类型，DCI、DIGITAL_SERVICE、MONITOR、RECORD_SCREEN
        const res = await getPayResult({
          dciWorkId: row.dciWorkId,
          bizType: 'DIGITAL_SERVICE'
        })
        if (res.code != 200) {
          return
        }
        console.log(res, 'getPayResultgetPayResult')
      }

      // if (row.serviceFeeStatus == 'PAIED') {
      //   // 跳转支付页面
      //   const res2 = await dciGetPayUrl([row.digitalRegisterId])
      //   if (res2.code == 200) {
      //     // window.open(res2.msg, '_blank')
      //     openPaymentWindow(res2.msg)
      //   }
      //   return
      // }
      this.onPaymentDialog([row]);
    },
    async onPaymentDialog(rowList = []){
      if(!(rowList.length > 0)){
        this.$message.warning('没有可用支付订单')
        return 
      }
      // 【新代码-弹窗支付】
      // const amount = rowList.reduce((total, row) => {
      //   return total + (toNumber(row.serviceFee) + toNumber(row.interfaceCost))
      // }, 0)
      const amount = rowList.reduce((total, row) => {
        return total + toNumber(row.serviceFee)
      }, 0)
      this.$refs.paymentDialog.open({
        amount: amount.toFixed(2),
        rowList,
        onAlipay: this.handlePaymentAlipay.bind(this),
        onBalance: this.handlePaymentBalance.bind(this),
      })
    },
    // 支付弹窗 - 支付宝支付回调
    async handlePaymentAlipay (paymentInfo) {
      const { rowList = [] } = paymentInfo || {}
      const idList = rowList.map(row => row.dciWorkId)
      const res = await payDigitalReg(idList,{ payType: PAY_TYPE.TRANSFER })
      if (res.code == 200) {
        if (res.msg) {
          openPaymentWindow(res.msg)
        }
        this.search()
        this.dialogVisible = true
      }
    },
    // 支付弹窗 - 余额支付回调
    async handlePaymentBalance (paymentInfo) {
      const { rowList = [] } = paymentInfo || {}
      const idList = rowList.map(row => row.dciWorkId)
      const res = await payDigitalReg(idList,{ payType: PAY_TYPE.BALANCE })
      if (res.code == 200) {
        // TODO: 调用余额支付接口
        this.$message.success('余额支付成功')
        this.search()
      }
    },
     // 批量支付
    async onBatchPay(){
      const rowList = this.multipleSelection.filter(row => this.getIsCanPay(row))
      await this.onPaymentDialog(rowList)
    },
    dialogVisibleClick () {
      this.search()
      this.dialogVisible = false
    },
    // async reissueCertificateClick (row) {
    //   const res = await payRecordScreen([row.dciWorkId], {
    //     phone: '17775134263',
    //     smsCode: '666'
    //   })
    //   if (res.code == 200) {
    //     // 打开一个空白的新窗口
    //     const newWindow = window.open('', '_blank', 'width=800,height=600')
    //     newWindow.document.write(res.msg)
    //   }
    // },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 补加DCI
    toAddCdi () {},
    async refundClick () {
      // 类型，DCI、DIGITAL_SERVICE、MONITOR、RECORD_SCREEN
      // 返回值是REFUNDED、REFUNDING。已退款和退款中。后面退款中的会定时任务1分钟一次的刷新，可以考虑提供单个退款状
      const res = await refund({
        dciWorkId: this.refundClickinfo.dciWorkId,
        dciContentId: this.refundClickinfo.dciContentId,
        bizType: 'DIGITAL_SERVICE'
      })
      if (res.code == 200) {
        this.$message.success('退款成功')
        this.search()
      }
    },
    // 管理员删除作品
    adminCancelClick (row) {
      this.$confirm('此操作将永久删除该作品，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await cancelDciWork(row.dciWorkId)
        if (res.code == 200) {
          this.$message.success('删除成功')
          this.search()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.status-tabs {
  margin: 0 50px;
  
  ::v-deep .el-tabs__header {
    margin-bottom: 15px;
  }
  
  ::v-deep .el-tabs__nav-wrap {
    overflow: visible;
  }
  
  ::v-deep .el-tabs__nav {
    width: 100%;
    display: flex;
    
    .el-tabs__item {
      flex: 1;
      text-align: center;
      padding: 0 20px;
      height: 50px;
      line-height: 50px;
    }
  }
  
  ::v-deep .el-badge {
    .el-badge__content {
      top: 10px;
      right: 5px;
    }
  }
}

.wenzi {
  height: 80px;
  margin-left: 50px;
  text-align: center;
  line-height: 80px;

  letter-spacing: normal;
  color: #333333;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}

.btn-upd {
  margin-left: 100px;
}

.table-dci {
  width: 1200px;
  margin: 0 auto;
}

.pagination {
  text-align: end;
  margin-top: 20px;
}

.showApp {
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  text-transform: none;

  // width: 294px;
  display: inline-block;
  padding: 0 5px;
  height: 25px;
  line-height: 25px;
  background: inherit;
  background-color: rgba(242, 242, 242, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(121, 121, 121, 1);
  border-radius: 5px;
  box-shadow: none;
  text-align: left;
  margin: 10px 0;
}

.showName {
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  cursor: pointer;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}

.showStatus {
  letter-spacing: normal;
  line-height: normal;
  font-size: 18px;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  color: #169bd5;
  text-align: center;
  word-wrap: break-word;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}

.status-info {
  text-align: center;
}

.status-fee {
  display: inline-block;
  padding: 6px 12px;
  background: linear-gradient(135deg, #ff9a56 0%, #ff6b35 100%);
  color: #fff;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  em {
    font-style: normal;
    font-weight: 700;
  }
}

.status-paying {
  display: inline-block;
  padding: 6px 16px;
  background: linear-gradient(135deg, #ffd93d 0%, #ffb800 100%);
  color: #8b6914;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.status-paid {
  display: inline-block;
  padding: 6px 16px;
  background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
  color: #fff;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
}

.input-with-select-cc {
  width: 400px;
}

.showTime-cc {
  margin-left: 30px;
}
.dialog-tuikuan-z {
  > div {
    margin: 40px 0;
    color: red;
    font-size: 16px;
  }
}
</style>
